<template>
  <div>
    <div class="p-md">
      <h1 class="title is-3 has-text-weight-light">Ré-inscription</h1>
    </div>
    <div class="app-block p-md m-md">
      <form @submit.prevent="send">
        <h3 class="heading-line title is-4 has-text-weight-light"><span
            :class="'school-title-'+schoolSlug">2 - Formation envisagée</span>
        </h3>
        <div class="content">

          <div class="columns">
            <div class="column has-text-centered">
              <a type="button" @click="toggleTrainings"
                 class="button">
                                    <span class="m-r-md" v-if="choice.training_name">
                                        <strong>{{ choice.training_name }}</strong>
                                    </span>
                <span v-else class="m-r-md" :class="[ errors.has('training') ? 'has-text-danger' : '']">Choix de la formation </span>
                <i :class="trainingList ?'fa fa-angle-up':'fa fa-angle-down'"></i>
              </a>
              <span v-show="errors.has('training')" class="help is-danger">{{ errors.first('training') }}</span>
            </div>
          </div>
          <div class="columns ">
            <div class="column has-text-centered">
              <transition name="slide-fade">
                <div v-if="trainingOptions.length > 0" class="m-md">
                                    <span v-for="option in trainingOptions" :key="option.id"
                                          class="has-text-left training-options">
                                        <a class="button m-md"
                                           :class="[selectedOption === option.id ? 'selected-option':'']"
                                           @click="optionChoice(option)">{{ option.name }}</a>
                                    </span>
                  <span v-show="errors.has('trainingOption')" class="help is-danger">{{
                      errors.first('trainingOption')
                    }}</span>
                </div>
                <div v-else-if="choice.training_option_id && !selectedTraining" class="m-md">
                                    <span class="has-text-left training-options">
                                        <a class="button m-md"
                                           :class="'selected-option'">{{ choice.training_option_name }}</a>
                                    </span>
                </div>
              </transition>
            </div>
          </div>
          <div class="columns ">
            <div class="column has-text-centered">
              <transition name="slide-fade">
                <div v-show="trainingList" class="m-md">
                  <div class="tile is-ancestor">
                    <div class="tile is-vertical is-parent" v-for="column in chunkedThemes" >

                      <div class="tile is-child" v-for="theme in column" v-if="theme.trainings.length">
                        <h3 class="heading-line has-text-weight-light"
                            v-if="theme.name !== 'notheme'"><span
                            :class="'school-title-'+schoolSlug">{{ theme.name }}</span></h3>
                        <div v-for="training in theme.trainings" :key="training.id"
                             class="has-text-left training-link">
                          <a class="button" style="display: flex"
                             @click="trainingChoice(training)">
                            <img style="width: 11rem; padding-right: 1em;" v-if="school.slug !== training.school.slug" :src="'/img/logos/'+ training.school.slug+'.png'" class="school-logo" alt="">
                            <span>{{ training.name }}</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <div class="columns ">
            <div class="column is-offset-3 is-3" v-show="campusList.length > 1">
              <h5><label class="label"
                         v-bind:class="[ errors.has('campus') ? 'has-text-danger' : '']">Campus</label>
              </h5>
              <b-select v-model="choice.campus_id"
                        v-validate="'required'" name="campus" :disabled="campusList.length === 0">
                <option disabled value="">Choix de la ville</option>
                <option
                    v-for="campus in campusList"
                    :value="campus.id"
                    :key="campus.id">
                  {{ campus.name }}
                </option>
              </b-select>
            </div>
            <div class="column" :class="campusList.length <= 1 ? 'is-offset-5 is-3':''">
              <h5><label class="label"
                         v-bind:class="[ errors.has('year') ? 'has-text-danger' : '']">Année</label></h5>
              <b-select v-model="choice.scholar_year"
                        v-validate="'required'" name="year">
                <option disabled value="">Année scolaire</option>
                <option
                    v-for="option in scholarYears"
                    :value="option.value"
                    :key="option.value">
                  {{ option.label }}
                </option>
              </b-select>
            </div>
          </div>

          <div class="columns m-t-md">
            <div class="column is-offset-1">
              <h5 v-if="choice.scholar_year !== 'other'">
                <strong>Frais de scolarité annuels :</strong>
                <span v-if="choiceFees">{{ choiceFees }}</span>
                <span v-else><i>choisissez une formation</i></span>
              </h5>
            </div>
          </div>
        </div>

        <div class="has-text-right">
          <transition name="slide-fade">
            <div class="has-text-danger has-text-centered">{{ errorMsg }}</div>
          </transition>

          <button :class="'button-valid button ' + isLoading" v-if="isLoggedIn">
            Sauvegarder
          </button>
          <button class="button" v-else disabled>
            Sauvegarder
          </button>
        </div>

      </form>
    </div>
  </div>

</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import api from 'services/organization'
import _ from "lodash";
import CountriesFR from "../../../utils/countries_fr.json";
import CountriesEU from "../../../utils/euro-countries.json";

export default {
  data() {
    return {
      isLoading: '',
      errorMsg: '',
      error: '',
      choiceValid: true,
      trainingList: false,
      trainingOptions: [],
      selectedOption: null,
      selectedTraining: false,
      choice: {},
      choiceFees: null,
      schools: [],
      campusList: this.campuses,
      countries: CountriesFR,
      countriesEU: CountriesEU,
    }
  },
  props: {
    school: {type: Object},
    schoolSlug: {type: String},
    campuses: {type: Array},
    trainings: {type: Array},
    candidate: {type: Object},
    application: {type: Object},
    choices: {type: Array}
  },
  watch: {
    choiceYear: {
      handler(val) {
        this.fees()
      },
    },
    choiceCampus: {
      handler(val) {
        this.fees()
      },
    },
    choiceTraining: {
      handler(val) {
        this.fees()
      },
    },
    choiceTrainingOption: {
      handler(val) {
        this.fees()
      },
    }
  },
  computed: {
    ...mapGetters({
      status: 'candidate/getStatus',
      isLoggedIn: 'auth/isLoggedIn',
      registeredCandidate: 'candidate/hasRegisteredApplication'
    }),
    ...mapGetters('organization', [
      'currentScholarYear'
    ]),
    choiceYear() {
      return this.choice.scholar_year;
    },
    scholarYears() {
      if (this.school) {
        return this.school.scholarYears
      }
    },
    choiceCampus() {
      return this.choice.campus_id;
    },
    choiceTraining() {
      return this.choice.training_id;
    },
    choiceTrainingOption() {
      return this.choice.training_option_id;
    },
    europeanNationality() {
      return !this.account.nationality || Boolean(_.find(this.countriesEU, {code: this.account.nationality}));
    },
    chunkedThemes() {
      let trainings = this.trainings
      if (!this.europeanNationality) {
        trainings = trainings.map((element) => {
          return {...element, trainings: element.trainings.filter((t) => t.foreign_access === true)}
        })
      }

      const result = []

      // default size to two item
      let size = 5
      if (trainings.length < 5) {
        size = 2
      }

      // add each chunk to the result
      for (let x = 0; x < Math.ceil(trainings.length / size); x++) {
        const start = x * size
        const end = start + size

        result.push(trainings.slice(start, end))
      }
      return result
    },
    applicationLog() {
      if (!this.candidate.application_log) {
        return null;
      }

      let logs = this.candidate.application_log.filter(application => application.id !== this.application.id);

      if (logs.length === 0) {
        return null;
      }

      let orderedLogs = _.orderBy(logs, log => new Date(log.accepted_date), 'desc');

      return orderedLogs[0];
    },
  },
  methods: {
    ...mapActions({
      sendChoices: 'candidate/saveChoices'
    }),
    toggleLoading: function () {
      this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
    },
    toggleTrainings() {
      this.choiceFees = ''
      this.trainingOptions = []
      this.trainingList = !this.trainingList
    },
    fees: function () {
      if (this.choice.training_id && this.choice.campus_id && this.choice.scholar_year) {
        if (this.choice.scholar_year !== 'other') {
          const year = this.choice.scholar_year.split('/')
          api.trainingFees(this.choice.training_id, {
            params: {
              'option': this.choice.training_option_id,
              'campus': this.choice.campus_id,
              'year': year[0]
            }
          }).then((result) => {

            if (result.data.fees || result.data.registered_fees) {
              this.choice.fees = result.data
              if (result.data.registered_fees && this.registeredCandidate(this.candidate.id) && !this.applicationLog.canceled_application) {
                this.choiceFees = result.data.registered_fees + ' euros'
              } else {
                if (result.data.fees) {
                  this.choiceFees = result.data.fees + ' euros'
                } else {
                  this.choiceFees = 'veuillez appeler le 04 67 920 910 pour obtenir des informations sur nos conditions et tarifs.'
                }
              }
            } else {
              this.choiceFees = 'veuillez appeler le 04 67 920 910 pour obtenir des informations sur nos conditions et tarifs.'
            }

          })
        }
        if (this.choice.scholar_year === this.currentScholarYear.value) {
          const prepaIntesive = [1, 2, 7, 8, 9, 10]
          if (prepaIntesive.includes(this.choice.training_option_id)) {
            api.trainingFees(this.choice.training_id, {
              params: {
                'option': this.choice.training_option_id,
                'campus': this.choice.campus_id,
                'year': '2018'
              }
            }).then((result) => {
              if (result.data.fees) {
                this.choice.fees = result.data
                this.choiceFees = result.data.fees + ' euros'
              } else {
                this.choiceFees = 'veuillez appeler le 04 67 920 910 pour un devis personnalisé'
              }

            })
          } else {
            this.choiceFees = 'veuillez appeler le 04 67 920 910 pour un devis personnalisé'
          }

        }
        if (this.choice.scholar_year === 'other') {
          this.choiceFees = null
        }
      }
    },
    getSchools() {
      api.schools().then((result) => {
        const schools = result.data
        for (let i = 0; i < schools.length; i++) {
          api.schoolTrainings(schools[i]['slug']).then((result) => {
            schools[i]['trainings'] = result.data
          }).catch(e => {

          })
          this.schools = schools
        }
        if (!_.isEmpty(this.application.choices)) {
          this.setCampuses(this.application.choices[0].training.school_id)

        }
      }).catch(e => {
      })
    },
    trainingChoice(training) {
      this.trainingList = false
      this.selectedTraining = true
      this.choice.school_id = training.school_id
      this.choice.training_id = training.id
      this.choice.training_name = training.name
      this.selectedOption = null
      this.choice.training_option_id = ''
      this.choice.training_option_name = ''
      if (training.options.length > 0) {
        this.trainingOptions = training.options
      } else {
        this.trainingOptions = []
      }
      this.$scrollTo('.choices-block-' + this.candidate.id, {offset: -10}, 500)
      this.fees()
      this.setCampuses(training.school_id)
    },
    setCampuses(id) {
      const school = this.schools.filter(function (obj) {
        return obj.id === id
      })
      this.campusList = school[0].campuses
      if (this.campusList.length === 1) {
        this.choice.campus_id = this.campusList[0].id
      }
    },
    optionChoice(option) {
      this.selectedOption = option.id
      this.choice.training_option_id = option.id
      this.choice.training_option_name = option.name
      this.fees()
    },
    send: function () {
      this.errors.clear()
      this.$validator.validateAll().then((result) => {
        if (result && this.choice.training_id) {
          // If the training has more than one option
          if ((this.trainingOptions.length > 1 && this.selectedOption) || this.trainingOptions.length <= 1) {
            this.toggleLoading()
            this.choice.school_name = this.school.name
            const campusId = this.choice.campus_id
            const campus = this.campuses.filter(function (obj) {
              return obj.id === campusId
            })
            this.choice.campus_name = campus[0]['name']

            const choicesList = {}
            choicesList.candidate_id = this.candidate.id
            choicesList.application_id = this.application.id
            choicesList.choices = []
            choicesList.choices.push(this.choice)

            this.sendChoices(choicesList).then((result) => {
              if (this.status === 200) {
                this.toggleLoading()
                this.$emit('send')
              } else if (this.status === 403) {
                this.toggleLoading()
                this.$emit('notAuthenticated')
              } else {
                this.toggleLoading()
                this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
              }
            }).catch(() => {
              this.toggleLoading()
              this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
            })

          } else {
            this.errors.add('trainingOption', 'Veuillez sélectionner une option ou une année')
          }
        } else {
          if (!this.choice.training_id) {
            this.errors.add('training', 'Veuillez sélectionner une formation')
          }
        }
      })
    }
  },
  created() {
    this.getSchools()
    if (!_.isEmpty(this.application.choices)) {
      this.choice = this.application.choices[0]
    }
  }
}
</script>

<style lang="scss">
.selected-option {
  background-color: #0f1e44;
  color: white;

  &:hover {
    background-color: #0f1e44;
    color: white;
  }
}
</style>
